import { Colors } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const SuccessWrapper = styled.div<{
    mobile?: boolean
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: min(90vw, 1152px);
    padding: ${p => p.mobile ? "16px" : "56px 0 72px"};
    margin: ${p => p.mobile ? "24px 0" : "48px 0"};
    background-color: ${p => p.theme.sendGift.background};
`

export const SuccessMobileWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 16px;
    max-width: 95vw;
    text-align: center;
`

export const SuccessTitle = styled.div<{
    mobile?: boolean
}>`
    font-family: Inter;
    font-size: ${p => p.mobile ? "28px" : "43px"};
    font-weight: 600;
    line-height: ${p => p.mobile ? "34px" : "51px"};
    letter-spacing: -0.02em;
    margin-bottom: 16px;
    text-align: center;
    color: ${p => p.theme.sendGift.text};
`

export const SuccessInfo = styled.div`
    max-width: 540px;
    box-sizing: border-box;
    padding: 32px;
    background-color: ${p => Colors.galBlack10 || p.theme.sendGift.white};
    margin: 24px 0;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (max-width: ${LayoutConst.screen.s}px) {
       padding: 0;
       width: 100%;
    };
`

export const SuccessButtonsWrapper = styled.div<{centeredButtons?: boolean}>`
    display: flex;
    gap: 24px;
    justify-content: ${p => p?.centeredButtons ? 'center' : 'flex-end'};
    width: ${p => p?.centeredButtons ? '100%' : 'auto'};
    width: 540px;
    button {
        // font-size: 17px;
        // font-style: normal;
        // font-weight: 600;
        // line-height: 22px;
        // letter-spacing: -0.34px;
        width: 50%;
        white-space:nowrap;
    }
    @media (max-width: ${LayoutConst.screen.s}px) {
       flex-direction: column;
        gap: 10px;
        width: 100%;
        button {
            width: 100%;
        }
    };
`

export const SuccessText = styled.div`
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack73};
`

export const SummaryInfoWrapper = styled.div`
    cursor: pointer;
    @media (max-width: ${LayoutConst.screen.s}px) {
       background: #F2F2F2;
       padding: 16px;
       width: 100%;
    };
    
`import { Colors } from "@brg/ui";
import { LayoutConst } from "core";
import styled from "styled-components";

export const SuccessWrapper = styled.div<{
    mobile?: boolean
}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: min(90vw, 1152px);
    padding: ${p => p.mobile ? "16px" : "56px 0 72px"};
    margin: ${p => p.mobile ? "24px 0" : "48px 0"};
    background-color: ${p => p.theme.sendGift.background};
`

export const SuccessMobileWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 16px;
    max-width: 95vw;
    text-align: center;
`

export const SuccessTitle = styled.div<{
    mobile?: boolean
}>`
    font-family: Inter;
    font-size: ${p => p.mobile ? "28px" : "43px"};
    font-weight: 600;
    line-height: ${p => p.mobile ? "34px" : "51px"};
    letter-spacing: -0.02em;
    margin-bottom: 16px;
    text-align: center;
    color: ${p => p.theme.sendGift.text};
`

export const SuccessInfo = styled.div`
    max-width: 540px;
    box-sizing: border-box;
    padding: 32px;
    background-color: ${p => Colors.galBlack10 || p.theme.sendGift.white};
    margin: 24px 0;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (max-width: ${LayoutConst.screen.s}px) {
       padding: 0;
       width: 100%;
    };
`

export const SuccessButtonsWrapper = styled.div<{centeredButtons?: boolean}>`
    display: flex;
    gap: 24px;
    justify-content: ${p => p?.centeredButtons ? 'center' : 'flex-end'};
    width: ${p => p?.centeredButtons ? '100%' : 'auto'};
    width: 540px;
    button {
        // font-size: 17px;
        // font-style: normal;
        // font-weight: 600;
        // line-height: 22px;
        // letter-spacing: -0.34px;
        width: 50%;
        white-space:nowrap;
    }
    @media (max-width: ${LayoutConst.screen.s}px) {
       flex-direction: column;
        gap: 10px;
        width: 100%;
        button {
            width: 100%;
        }
    };
`

export const SuccessText = styled.div`
    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: ${Colors.galBlack73};
`

export const SummaryInfoWrapper = styled.div`
    cursor: pointer;
    @media (max-width: ${LayoutConst.screen.s}px) {
       background: #F2F2F2;
       padding: 16px;
       width: 100%;
    };
    
`